import { render, staticRenderFns } from "./reports-container.vue?vue&type=template&id=a2efae36"
import script from "./reports-container.vue?vue&type=script&lang=ts"
export * from "./reports-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports